import { render, staticRenderFns } from "./commonDateStatus.vue?vue&type=template&id=63736018&scoped=true"
import script from "./commonDateStatus.vue?vue&type=script&lang=js"
export * from "./commonDateStatus.vue?vue&type=script&lang=js"
import style0 from "./commonDateStatus.vue?vue&type=style&index=0&id=63736018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63736018",
  null
  
)

export default component.exports